<template>
  <section class="hero"></section>
</template>

<script>
  export default {
    name:'Hero',
    data(){
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Hero.vue